import { registerControllers } from 'stimulus-vite-helpers'
import {
  Toggle,
  Modal
} from 'tailwindcss-stimulus-components'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import AutoSubmit from '@stimulus-components/auto-submit'
import ScrollTo from '@stimulus-components/scroll-to'
import Sortable from '@stimulus-components/sortable'
import ReadMore from '@stimulus-components/read-more'

import { stimulus } from '~/init'

stimulus.register('auto-submit', AutoSubmit)
stimulus.register('modal-sync', Modal)
stimulus.register('toggle', Toggle)
stimulus.register('textarea-autogrow', TextareaAutogrow)
stimulus.register('scroll-to', ScrollTo)
stimulus.register('sortable', Sortable)
stimulus.register('read-more', ReadMore)

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(stimulus, controllers)
